<template>
    <div class="house-header"> 
        <div class="logo-container">
            <img src="@/assets/logo.png" alt="logo" class="logo-img">
            <div class="logo-title"><h2>凯尚设计</h2></div>
        </div>

        <div class="search-container">
            <div class="search">
                <input type="text" placeholder="搜户型" v-model="keyword"
          @keyup.enter="searchHouses(keyword)">
                
            </div>
          <div><button class="search-button" @click="searchHouses(keyword)">搜索</button></div>
        </div>
        

    </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const keyword = ref('');
const router = useRouter();

const searchHouses = (houseName) => {
    houseName = houseName?.trim() || ''; 
    router.push({
        name: 'HouseSearch',
        query: { houseName } 
    });
};
</script>


<style scoped>
:global(body),
:global(html) {
  margin: 0;
  padding: 0;
}


.house-header { 
    width: 100%;
    height: 60px;
    /* background: #d1e5fd; */
    background: #e5ebf3;
    display: flex;
    flex-direction: space-between;
    position:relative;
}

.logo-container{
    display: flex;
    margin-left: 130px;
    align-items: center;
    /* justify-content: space-between */
}
.logo-img{
    /* border-radius: 50%; */
    width: 35px;
    height: 35px;
}
.logo-title{
    margin-left: 10px;
    color: black;
    font-weight: 600;
    font-size: 14px;
}

.search-container{
    display: flex;
    position: absolute;
    right: 100px;
    width: 200px;
    height: 60px;
}
.search input[type="text"] {
  position: absolute; 
  top: 17px;
  right: 50px;
  width: 150px;
  height: 8px;
  background-color: white;
  padding: 10px;
  border: 1px solid white;
  border-radius: 4px 0 0 4px ;
  transition: all 0.3s ease;
}
.search input[type="text"]:focus {
  width: 200px;
  border: none;
  outline: none;
  z-index: 10;
}
.search-button{
  position: absolute;
  top: 17px;
  right: 0;
  width: 50px;
  height: 28px;
  background-color: rgb(44, 126, 248);;
  color: white;
  border: none;
  font-size: 0.875rem;
  border-radius:  0 0.375rem 0.375rem 0;
  cursor: pointer;
}
.search-button:hover{
  background-color:  #0067F8;;
}

@media (max-width: 768px) {
    .logo-container{
        margin-left: 10px;
    }

    .search-container{
        right: 10px;
    }

    .logo-title{
        font-size: 12px;
    }
}
@media (max-width: 429px) {
    .logo-container{
        margin-left: 10px;
    }

    .search-container{
        right: 10px;
    }

    .search input[type="text"] {
        top: 17px;
        width: 120px;
    }
    .search input[type="text"]:focus {
        width: 150px;
    }
}
</style>